import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, Rating, Text } from "@wojo/ui";
import { useTourPageContext } from "../../_client/context";
import { scrollToSection, TourSectionId } from "../../_client/hooks";
import style from "./TourHeroSummaryInfo.module.scss";

export const TourHeroReviews: React.FC = () => {
    const { reviewAggregate: reviews, navRef } = useTourPageContext();
    const { productPage } = useI18n("productPage");

    if (!reviews?.avgRating || !reviews.nbReviews) {
        return null;
    }
    return (
        <Text tag="dl" className={style["summary-info-detail-wrapper"]}>
            <Text tag="dt">{productPage.tourHero.heroSummary.reviews.l()}</Text>
            <Text tag="dd" className={style["summary-info-detail"]}>
                <Rating
                    value={reviews.avgRating}
                    variant="bold"
                    style={{ justifySelf: "flex-end" }}
                    adornRight={
                        <Button
                            variant="quiet"
                            tag="a"
                            href={`#${TourSectionId.REVIEWS}`}
                            aria-label={`${
                                reviews.nbReviews
                            } ${productPage.tourHero.heroSummary.reviews
                                .l()
                                .toLowerCase()}`}
                            onClick={(
                                e: React.MouseEvent<HTMLAnchorElement>,
                            ) => {
                                gtmSendEvent({
                                    event: "track",
                                    ga4Tracking: {
                                        ga4_action: "CLICKED",
                                        ga4_object: "ELEMENT",
                                        elementType: "link",
                                        elementID: "heroReview",
                                        reviewType: "heroReview",
                                    },
                                });
                                scrollToSection(e, navRef);
                            }}
                        >
                            {reviews.nbReviews}
                        </Button>
                    }
                />
            </Text>
        </Text>
    );
};
